import React, {useEffect} from 'react';

import {ProactForm, ProactFormGrid} from 'src/app/forms/engine/ProactForm';
import {useProactForm} from 'src/app/forms/engine/useProactForm';
import {FormViewComponentV2} from 'src/app/forms/FormViewComponent/FormViewComponentV2';
import type {IFormDataV2} from 'src/types/FormV2';
import {LessonFormMeta} from '../../../../../app/training/courseFormMeta';

export interface LessonFormProps {
  data: IFormDataV2;
  mode: 'edit' | 'view';
  onFormValidate?: (isFormValid: boolean) => void;
  onFormDataChange?: (data: IFormDataV2) => void;
}

export const LessonForm: React.FC<LessonFormProps> = ({
  data,
  mode,
  onFormValidate,
  onFormDataChange,
}) => {
  const form = useProactForm({
    formMeta: LessonFormMeta,
    initialData: data,
    enablePreSubmissionValidation: false,
  });
  const {methods, validateForm} = form;

  useEffect(() => {
    if (mode !== 'edit') {
      return;
    }
    void validateForm().then(isValid => onFormValidate?.(isValid));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mode]);

  useEffect(() => {
    if (mode !== 'edit') {
      return;
    }
    const subscription = methods.watch((values, {name}) => {
      if (!name) {
        return;
      }
      onFormDataChange?.({...values});
      void validateForm().then(isValid => onFormValidate?.(isValid));
    });
    return () => subscription.unsubscribe();
  }, [mode, methods, onFormDataChange, onFormValidate, validateForm]);

  return mode === 'edit' ? (
    <ProactForm form={form}>
      <ProactFormGrid />
    </ProactForm>
  ) : (
    <FormViewComponentV2 formData={data} formMeta={LessonFormMeta} />
  );
};
